import httpServiceMain from "./httpServiceMain";

const serialize = (params: Record<string, any>): string => {
	const query = Object.entries(params)
		.filter(([, v]) => v !== undefined && v !== null)
		.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
		.join("&");
	return query ? `?${query}` : "";
};

export const getChatList = async (params: any) => {
	const paramsSerialized = serialize(params);
	return httpServiceMain.get(`/chats${paramsSerialized}`);
};

export const postChatMessage = async (params: any) => {
	return httpServiceMain.post("/chats/messages/", params);
};

export const getChat = async (params: { chat_id: string | number }) => {
	return httpServiceMain.get(`/chats/${params.chat_id}`);
};

export const getUnreadMessagesCount = async () => {
	const systemId = import.meta.env.VITE_SYSTEM_ID;
	return httpServiceMain.get(`/chats/messages/unread/count${serialize({ mg_network_system_id: systemId })}`);
};

export const deleteUserChat = async (chatId: string | number) => {
	return httpServiceMain.delete(`/chats/${chatId}`);
};

export const deleteChatMessage = async (chatMessageId: string | number) => {
	return httpServiceMain.delete(`/chats/messages/${chatMessageId}`);
};
